import { action } from 'satcheljs';
import type { InsightsDataFetchSource } from 'owa-meeting-insights-types-and-flights';

export const setHasScrolledInDetailsForm = action(
    'setHasScrolledInDetailsForm',
    (hasScrolled: boolean) => ({ hasScrolled })
);

export const resetRelatedContentViewState = action('resetRelatedContentViewState');

export const tryFetchRelatedContentInsights = action(
    'tryFetchRelatedContentInsights',
    (eventId: string, dataFetchSource: InsightsDataFetchSource) => ({
        eventId,
        dataFetchSource,
    })
);
